import React, {useCallback, useState, useEffect} from "react";
import EditItemView from "../EditItemView";
import {FEATURE} from "../../model/features";
import {Form, Modal} from "react-bootstrap";
import ScheduleName from "../../components/ScheduleName";
import {OPERATING_DAY_DEFAULTS, OperatingDays, Period, PREDEFINED_SCHEDULES, Exception, Schedule} from "../../model/schedule";
import util from "util";
import {DatePicker, Select, Row, Col, Button, Tag, Divider} from "antd";
import {capitalize} from "lodash";
import {scheduleModelData} from "../../services/ModelService";
import ScheduleCalendar from "../../components/ScheduleCalendar";
import {ReactComponent as Close} from "../../assets/icons/Close.svg";
import {ReactComponent as Plus} from "../../assets/icons/Plus.svg";

const {Option} = Select
const {RangePicker} = DatePicker;

function EditScheduleView(props) {
    const [schedule, setSchedule] = useState(props.editing);
    const [showPreview, setShowPreview] = useState(false);
    const [runningDates, setRunningDates] = useState([]);
    const [exceptionAddType, setExceptionAddType] = useState('custom');
    const [exceptionAddSourceIdx, setExceptionAddSourceIdx] = useState(undefined);
    const { hideCalendar } = props;

    // Update running dates whenever schedule changes
    useEffect(() => {
        const scheduleInstance = new Schedule(schedule);
        setRunningDates(scheduleInstance.getRunningDates(scheduleInstance.getFirstActiveDate()));
    }, [schedule]);

    const schoolPeriodButtons = useCallback((include, schedule) => {
        // setSchedule(schedule => {

        const type = include ? 'Include calendars' : 'Exclude calendars'
        // const setIncludePeriods = include ? setSchedulePeriods : setExcludedPeriods
        // const setExcludePeriods = include ? setExcludedPeriods : setSchedulePeriods
        const subSchedules = include ? schedule.includedSchedules : schedule.excludedSchedules

        return (
            <div>
                <Select className={'mt-2'} style={{width: '267px'}} value={'none'} onChange={(val, el) => {
                    if (val.startsWith('schedule')) {

                        const sId = val.split(':')[1]
                        subSchedules.push(PREDEFINED_SCHEDULES[sId] || props.items[sId])
                        setSchedule({...schedule})
                        // setIncludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(schedules[sId].schedulePeriods))
                        // setExcludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(schedules[sId].excludedPeriods))
//                     } else if (val === 'schoolYear') {
//                         schedules.push(SCHOOL_YEAR_SCHEDULE)
//                         // setIncludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(SCHOOL_YEAR_PERIOD))
//                     } else if (val === 'schoolTerms') {
//                         schedules.push(SCHOOL_TERMS_SCHEDULE)
//                         // setIncludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(SCHOOL_TERM_PERIODS))
//                     } else if (val === 'schoolHols') {
//                         schedules.push(SCHOOL_HOLIDAY_SCHEDULE)
// // setIncludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(SCHOOL_HOLIDAYS))
//                     } else if (val === 'publicHols') {
                        // setIncludePeriods(periods => (periods || []).filter(p => p.isValid()).concat(PUBLIC_HOLIDAY_PERIODS))
                    }
                    el.value = 'none'
                }}>

                    <Option key={`choose-${type}`} value={'none'}>{type}</Option>
                    {Object.keys(PREDEFINED_SCHEDULES).filter(sId => subSchedules.every(subSchedule => subSchedule.scheduleId !== sId)).map(sId => {
                        const schedule = PREDEFINED_SCHEDULES[sId]
                        return <Option key={`${type}-${sId}`} value={`schedule:${sId}`}><ScheduleName schedule={schedule}/></Option>
                    })}
                    {Object.keys(props.items).filter(sId => sId !== schedule.scheduleId && (!subSchedules?.length || subSchedules.every(subSchedule => subSchedule?.scheduleId !== sId && !subSchedule.containsSubSchedule(schedule)))).map(sId => {
                        const schedule = props.items[sId]
                        return <Option key={`${type}-${sId}`} value={`schedule:${sId}`}><ScheduleName schedule={schedule}/></Option>
                    })}
                </Select>
            </div>
        )
    }, [props.items, setSchedule]);

    // Helper to get all prefilled periods (from PREDEFINED_SCHEDULES only, one entry per schedule)
    const getPrefilledPeriods = () => {
        return Object.values(PREDEFINED_SCHEDULES)
            .filter(sched => sched.schedulePeriods?.length)
            .map(sched => ({
                label: sched.scheduleName,
                scheduleId: sched.scheduleId
            }));
    };

    // Helper to get all prefilled periods (from PREDEFINED_SCHEDULES only)
    const prefilledPeriods = getPrefilledPeriods();

    // Add exception handler
    const handleAddException = (type) => {
        if (exceptionAddType === 'custom') {
            setSchedule(schedule => {
                schedule.exceptions = [...(schedule.exceptions || []), new Exception({ type })];
                return { ...schedule };
            });
        } else if (exceptionAddType === 'prefilled' && exceptionAddSourceIdx !== undefined) {
            const selected = prefilledPeriods[exceptionAddSourceIdx];
            if (selected && selected.scheduleId) {
                setSchedule(schedule => {
                    schedule.exceptions = [...(schedule.exceptions || []), new Exception({ type, scheduleId: selected.scheduleId, source: selected.label })];
                    return { ...schedule };
                });
            }
        }
        setExceptionAddType('custom');
        setExceptionAddSourceIdx(undefined);
    };

    return (
        <>
            {/* <div className="d-flex justify-content-end mb-3">
                <Button variant="outline-primary" size="sm" onClick={() => setShowPreview(true)}>
                    View Schedule Preview
                </Button>
            </div> */}
            <EditItemView item={schedule} feature={FEATURE.schdls} modelData={scheduleModelData} {...props}>
                <Row gutter={[30, 30]}>
                    <Col xs={24} lg={hideCalendar ? 24 : 10}>
                        <Row gutter={[20, 20]}>
                            <Col xs={24} lg={24}>
                                <Form.Group className="mb-0" controlId={schedule.scheduleId + '_ScheduleName'}>
                                    <Form.Label>Calendar Name</Form.Label>
                                    <Form.Control type="text" placeholder="Calendar name" className="w-100" style={{maxWidth: '500px'}} disabled={schedule.shared} value={schedule.scheduleName || ''}
                                        onChange={(e) => {
                                            setSchedule(schedule => {
                                                schedule.scheduleName = e.target.value;
                                                return {...schedule};
                                            })
                                        }}/>
                                </Form.Group>
                            </Col>
                            {/* Base Calendar Section */}
                            <Col xs={24} lg={24}>
                                <Form.Group className="mb-0" controlId={schedule.scheduleId + '_SchedulePeriods'}>
                                    <Form.Label className="mb-0">Base Calendar</Form.Label>
                                    {/* {!schedule.shared && schoolPeriodButtons(true, schedule)} */}
                                    {schedule.includedSchedules?.length ? schedule.includedSchedules.map((includedSchedule, idx) => (
                                        <div key={includedSchedule.scheduleId} className="d-flex flex-row">
                                            <div className="mt-2 ml-2" style={{width: '258px'}}><ScheduleName schedule={includedSchedule}/></div>
                                            <div className="mt-2 ml-2 d-flex justify-content-center align-items-center">
                                                {!schedule.shared && <Button className="sb-close" icon={<Close/>} 
                                                    onClick={() => {
                                                        setSchedule(schedule => {
                                                            schedule.includedSchedules.splice(idx, 1)
                                                            return {...schedule};
                                                        })
                                                    }}/>}
                                            </div>
                                        </div>
                                    )) : <></>}
                                    {schedule.schedulePeriods?.length ? schedule.schedulePeriods.map((schedulePeriod, idx) => (
                                        <div key={schedulePeriod.id} className="d-flex flex-row">
                                            <div className="mt-2 w-100" style={{maxWidth: '500px'}}>
                                                <RangePicker disabled={schedule.shared} className="w-100" style={{maxWidth: '500px'}}
                                                    onChange={(value) => {
                                                        setSchedule(schedule => {
                                                            const period = schedule.schedulePeriods[idx]
                                                            period.update(value)
                                                            return {...schedule};
                                                        })
                                                    }}
                                                    value={[schedulePeriod.start, schedulePeriod.end]}
                                                    format={"DD/MM/YYYY"}
                                                />
                                            </div>
                                            <div className="mt-2 ml-2 d-flex align-items-center sb-edit-controls" style={{gap: 8, minWidth: 60}}>
                                                {!schedule.shared && <Button className="sb-close" icon={<Close/>} 
                                                    onClick={() => {
                                                        setSchedule(schedule => {
                                                            schedule.schedulePeriods.splice(idx, 1)
                                                            return {...schedule};
                                                        })
                                                    }}/>
                                                }
                                                {idx === schedule.schedulePeriods.length - 1 && <>
                                                    {!schedule.shared && <Button className="sb-add" icon={<Plus style={{width: 13, height: 13}}/>} 
                                                        onClick={() => setSchedule(schedule => {
                                                            schedule.schedulePeriods.push(new Period())
                                                            return {...schedule};
                                                        })}/>
                                                    }
                                                </>}
                                            </div>
                                        </div>
                                    )) : !schedule.shared ? <div className="mt-2">
                                        <RangePicker className="w-100" style={{maxWidth: '500px'}}
                                            onChange={(value) => {
                                                setSchedule(schedule => {
                                                    schedule.schedulePeriods = schedule.schedulePeriods.concat(new Period())
                                                    const newPeriod = schedule.schedulePeriods[schedule.schedulePeriods.length - 1]
                                                    newPeriod.update(value)
                                                    return {...schedule};
                                                })
                                            }}
                                            format={"DD/MM/YYYY"}
                                        />
                                    </div> : <></>}
                                </Form.Group>
                            </Col>
                            {/* Operating Days Section */}
                            <Col xs={24} lg={24}>
                                {!schedule.shared && <Form.Group className="mb-0" controlId="operatingDays">
                                    <Form.Label className="mb-0">Operating Days</Form.Label>
                                    <div className={'mb-2'}>
                                        <Select disabled={schedule.shared} className={'mt-2 w-100'} style={{maxWidth: '500px'}} value={'none'}
                                            onChange={(val, el) => {
                                                setSchedule(schedule => {
                                                    schedule.operatingDays = new OperatingDays(OPERATING_DAY_DEFAULTS[val])
                                                    return {...schedule};
                                                })
                                                el.value = 'none'
                                            }}>
                                            <Option key={`choose-op`} value={'none'}>Operating days</Option>
                                            {Object.keys(OPERATING_DAY_DEFAULTS).map(type => {
                                                return <Option key={`OD-${type}`} value={type}>{type}</Option>
                                            })}
                                        </Select>
                                    </div>
                                    <div className="d-flex flex-wrap flex-row" style={{rowGap: '10px'}}>
                                        {Object.keys(schedule.operatingDays).map(day => (
                                            <Form.Check disabled={schedule.shared} key={schedule.scheduleId + '_op_day_' + day} type="checkbox"
                                                label={capitalize(day)}
                                                id={schedule.scheduleId + '_op_day_' + day}
                                                onChange={(el) => {
                                                    const checkbox = el.target;
                                                    setSchedule(schedule => {
                                                        schedule.operatingDays[day] = checkbox.checked
                                                        return {...schedule};
                                                    })
                                                }}
                                                style={{ minWidth: '100px', width: '25%', marginBottom: '0px' }}
                                                checked={schedule.operatingDays[day]}/>
                                        ))}
                                    </div>
                                </Form.Group>}
                            </Col>
                            {/* Exceptions Section */}
                            <Col xs={24} lg={24}>
                                {!schedule.shared && <Form.Group className="mb-2" controlId="exceptions">
                                    <Form.Label>Exceptions</Form.Label>
                                    <div className={'mb-3'}>
                                        <Row gutter={[10, 10]} align="middle">
                                            <Col xs={24} lg={exceptionAddType === 'prefilled' ? 12 : 24}>
                                                <Select className="w-100"
                                                    value={exceptionAddType}
                                                    onChange={val => {
                                                        setExceptionAddType(val);
                                                        setExceptionAddSourceIdx(undefined);
                                                    }}
                                                >
                                                    <Option value="custom">Custom Range</Option>
                                                    <Option value="prefilled">Prefilled Period</Option>
                                                </Select>
                                            </Col>
                                            {exceptionAddType === 'prefilled' && (
                                                <Col xs={24} lg={12}>
                                                    <Select className="w-100"
                                                        showSearch
                                                        placeholder="Select a period"
                                                        value={exceptionAddSourceIdx}
                                                        onChange={idx => setExceptionAddSourceIdx(idx)}
                                                        filterOption={(input, option) =>
                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                        }
                                                    >
                                                        {prefilledPeriods.map((item, idx) => (
                                                            <Option key={item.label} value={idx}>{item.label}</Option>
                                                        ))}
                                                    </Select>
                                                </Col>
                                            )}
                                            <Col xs={24} lg={12}>
                                                <Button type="primary" className="btn-primary mr-2 w-100" style={{backgroundColor: '#6B54F9',borderColor: '#6B54F9"'}}
                                                    onClick={() => handleAddException('include')}
                                                    disabled={exceptionAddType === 'prefilled' && exceptionAddSourceIdx === undefined}
                                                >
                                                    Add Include Exception
                                                </Button>
                                            </Col>
                                            <Col xs={24} lg={12}>
                                                <Button className="btn-secondary w-100"
                                                    onClick={() => handleAddException('exclude')}
                                                    disabled={exceptionAddType === 'prefilled' && exceptionAddSourceIdx === undefined}
                                                >
                                                    Add Exclude Exception
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    {schedule.exceptions?.length ? <div className="schedule-exceptions-list">
                                        {schedule.exceptions?.map((exception, idx) => (
                                            <div key={exception.id} className={`schedule-exception ${exception.type === 'include' ? 'schedule-include' : 'schedule-exclude'}`}>
                                                <div className={`${exception.type === 'include' ? 'text-success' : 'text-danger'}`} style={{minWidth: '70px'}}>{capitalize(exception.type)}</div>
                                                {/* Show RangePicker for custom exceptions, summary for scheduleId-based */}
                                                {(!exception.scheduleId) ? (
                                                    <RangePicker className="w-100"
                                                        value={exception.period ? [exception.period.start, exception.period.end] : [null, null]}
                                                        onChange={(value) => {
                                                            setSchedule(schedule => {
                                                                if (!schedule.exceptions[idx].period) {
                                                                    schedule.exceptions[idx].period = new Period();
                                                                }
                                                                schedule.exceptions[idx].period.update(value);
                                                                // If user edits, clear the source tag
                                                                schedule.exceptions[idx].source = undefined;
                                                                return {...schedule};
                                                            });
                                                        }}
                                                        format="DD/MM/YYYY"
                                                    />
                                                ) : (<div className="w-100">
                                                    {exception.legacy && <Tag color="red">Legacy Excluded Period</Tag>}
                                                    {exception.source && <Tag color="blue">{exception.source}</Tag>}
                                                    <span style={{ flex: 1 }}>{exception.source ? `All dates in ${exception.source}` : ''}</span>
                                                </div>)}
                                                <div className="d-flex justify-content-center align-items-center sb-edit-controls">
                                                    <Button className="sb-close" icon={<Close/>} 
                                                        onClick={() => {
                                                            setSchedule(schedule => {
                                                                schedule.exceptions.splice(idx, 1);
                                                                return {...schedule};
                                                            });
                                                    }}/>
                                                </div>
                                            </div>
                                        ))}
                                    </div> : <></>}
                                </Form.Group>}
                            </Col>
                        </Row>
                    </Col>
                    {!hideCalendar && (
                        <Col xs={24} lg={14}>
                            <ScheduleCalendar
                                schedulePeriods={schedule.schedulePeriods}
                                operatingDays={schedule.operatingDays}
                                excludedPeriods={[]} // No longer used in UI
                                includedSchedules={schedule.includedSchedules}
                                excludedSchedules={schedule.excludedSchedules}
                                runningDates={runningDates}
                                calendarTitle="Schedule Calendar Preview"
                            />
                        </Col>
                    )}
                </Row>
            </EditItemView>

            <Modal 
                show={showPreview} 
                onHide={() => setShowPreview(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Schedule Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ScheduleCalendar
                        schedulePeriods={schedule.schedulePeriods}
                        operatingDays={schedule.operatingDays}
                        excludedPeriods={[]} // No longer used in UI
                        includedSchedules={schedule.includedSchedules}
                        excludedSchedules={schedule.excludedSchedules}
                        runningDates={runningDates}
                        calendarTitle="Schedule Calendar Preview"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPreview(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default React.memo(EditScheduleView);